<template>
  <v-container>
      <v-layout>
        <v-navigation-drawer temporary fixed right app width="265" :disable-resize-watcher="true" class="nav-menu" v-model="show">
          <v-toolbar flat color="blue lighten-1">
            <v-list>
              <v-list-tile>
                <v-list-tile-title class="title white--text">
                  Menu
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <v-divider></v-divider>
          <v-list two-line subheader>
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon>person</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                 <v-list-tile-title>{{currentUser.email}}</v-list-tile-title>
                 <v-list-tile-title>{{currentUser.firstname +" "+currentUser.lastname}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list dense class="pt-0" >
            <v-list-tile v-for = "item in menuItems1" :key="item.title" :to="item.href">
              <v-list-tile-action>
                <v-icon :color="item.color">{{item.icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content :class="item.color+'--text'">
                 {{item.title}}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list dense class="pt-0" >
            <v-list-group
                v-for="item in menuItems2"
                v-model="item.active"
                :key="item.title"
                :prepend-icon="item.action"
                no-action
              >
              <v-list-tile slot="activator">
                    <v-list-tile-content>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile
                      v-for="subItem in item.items"
                      :key="subItem.title"
                      :to="subItem.href"
                      :prepend-icon="subItem.icon">
                      <v-list-tile-content>
                        <v-list-tile-content :class="subItem.color+'--text darken-1'" style="font-weight:bold">{{ subItem.title }}</v-list-tile-content>
                      </v-list-tile-content>
                  </v-list-tile>
            </v-list-group>

          </v-list>
          <v-divider></v-divider>
          <v-list dense class="pt-0" >
            <v-list-tile :to="items[0].href">
              <v-list-tile-action>
                <v-icon :color="items[0].color">{{items[0].icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content :class="items[0].color+'--text'" >
                 {{items[0].title}}
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      
      <v-toolbar class="elevation-1 toolbar--fixed theme--dark pb-0" inline app >

        <v-toolbar-items class="pr-4">
          <img class="logo" src="../assets/metroWebLogo2-trans.png" @click="home()">
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-title class="headbar-title">{{title}}</v-toolbar-title>
        <v-toolbar-side-icon dark @click="show=!show"></v-toolbar-side-icon>
        
  </v-toolbar>
</v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  props: {showMenu: {type: Boolean}},
  data () {
    return {
      title: 'Display Case Manager',
      menuItems: ['Metro Blue Line', 'Metro Red Line', 'Metro Green Line', 'Metro Gold Line', 'Metro Purple Line', 'Metro Red Line'],
      drawer: null,
      items: [
        {title: 'Logout', icon: 'exit_to_app', href: '/logout', color: 'black'}
      ],
      show: false,
      right: null,
      menu: false
    }
  },
  computed: {
    ...mapGetters({currentUser: 'currentUser'}),
    menuItems1: () => {
      let items = [
        {title: 'Home', icon: 'home', href: '/', color: 'black'},
        {title: 'Search', icon: 'search', href: '/search', color: 'black'},
        {title: 'Export', icon: 'fas fa-file', href: '/report', color: 'black'},
        {title: 'History', icon: 'history', href: '/history', color: 'black'},
        {title: 'Create Tasks', icon: 'fas fa-list-ol', href: '/installation', color: 'black'},
        {title: 'Tasks', icon: 'fas fa-tasks', href: '/tasks', color: 'black'},
        {title: 'Installer Tasks', icon: 'fas fa-list-ol', href: '/installertasks', color: 'black'}
      ]
      return items
    },
    menuItems2: () => {
      let items = [
        {
          action: 'directions_railway',
          title: 'Metro Locations',
          items: [
            {title: 'Metro Blue Line', icon: 'directions_railway', href: '/rail/801', color: 'indigo'},
            {title: 'Metro Red Line', icon: 'directions_railway', href: '/rail/802', color: 'red'},
            {title: 'Metro Green Line', icon: 'directions_railway', href: '/rail/803', color: 'green'},
            {title: 'Metro Gold Line', icon: 'directions_railway', href: '/rail/804', color: 'amber'},
            {title: 'Metro Purple Line', icon: 'directions_railway', href: '/rail/805', color: 'purple'},
            {title: 'Metro Expo Line', icon: 'directions_railway', href: '/rail/806', color: 'light-blue'},
            {title: 'Metro Orange Line', icon: 'directions_bus', href: '/rail/901', color: 'orange'},
            {title: 'Metro Silver Line 910', icon: 'directions_bus', href: '/rail/910', color: 'grey'},
            {title: 'Metro Silver Line 950', icon: 'directions_bus', href: '/rail/950', color: 'grey'}
          ]
        },
        {
          action: 'directions_railway',
          title: 'Offsite Locations',
          items: [
            {
              title: 'Coming Soon..', icon: '', href: '', color: 'black'
            }
          ]
        },
        {
          action: 'settings',
          title: 'Settings',
          items: [
            {
              title: 'Enable Display Cases', icon: '', href: '/enablecases', color: 'black'
            }
          ]
        }
      ]
      return items
    }
  },
  methods: {
    something () {
      this.show = true
    },
    home () {
      this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  cursor: pointer;
}
.custom-layout{
  margin-top: 50px;
}
@media only screen and (max-width: 600px) {
  .logo {
    height:50px;
    width:140px;
    cursor: pointer;
  }
  .headbar-title{
    display:none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue